import waterpark1 from "./waterpark1.jpeg";
import waterpark2 from "./waterpark2.jpeg";

export {
    waterpark1,
    waterpark2
}